<template>
  <div class="hpsfir-card finance">
    <!-- 统计卡片 -->
    <div class="stat-cards">
      <el-card class="stat-card">
        <div class="stat-title">今日收入</div>
        <div class="stat-value">¥ {{ statVisible ? todayIncome : '****' }}</div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-title">本月收入</div>
        <div class="stat-value">¥ {{ statVisible ? monthIncome : '****' }}</div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-title">本季度收入</div>
        <div class="stat-value">¥ {{ statVisible ? quarterIncome : '****' }}</div>
      </el-card>
      <el-card class="stat-card">
        <div class="stat-title">本年收入</div>
        <div class="stat-value">¥ {{ statVisible ? yearIncome : '****' }}</div>
      </el-card>
      <div class="stat-toggle" @click="statVisible = !statVisible">
        <el-icon :size="18">
          <View v-if="statVisible" />
          <Hide v-else />
        </el-icon>
      </div>
    </div>
    <el-tabs v-model="activeTab" class="finance-tabs">
      <el-tab-pane label="支付记录" name="billRecord">
        <BillRecord v-if="activeTab === 'billRecord'" />
      </el-tab-pane>
      <el-tab-pane label="D币记录" name="coinsRecord">
        <CoinsRecord v-if="activeTab === 'coinsRecord'" />
      </el-tab-pane>
      <el-tab-pane label="积分记录" name="pointsRecord">
        <PointsRecord v-if="activeTab === 'pointsRecord'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { View, Hide } from '@element-plus/icons-vue';
import dayjs from 'dayjs';
import { useApi } from '@/hooks/useApi';
import BillRecord from './billrecord/index.vue';
import CoinsRecord from './coinsrecord/index.vue';
import PointsRecord from './pointsrecord/index.vue';

const activeTab = ref('billRecord');
const statVisible = ref(false);

const todayIncome = ref('0.00');
const monthIncome = ref('0.00');
const quarterIncome = ref('0.00');
const yearIncome = ref('0.00');

// 获取今日统计
const fetchTodayStats = async() => {
  try {
    const res = await useApi().statisticsApi.getTodayStatisticsstatistics();
    todayIncome.value = res.data.data?.totalIncome || '0.00';
  } catch {
    todayIncome.value = '0.00';
  }
};

// 获取本月统计
const fetchMonthStats = async() => {
  const year = dayjs().year();
  const month = dayjs().month() + 1;
  const periodStr = `${year}-${String(month).padStart(2, '0')}`;
  try {
    const res = await useApi().statisticsApi.getMonthlyIncomestatistics({ year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    monthIncome.value = current?.income || '0.00';
  } catch {
    monthIncome.value = '0.00';
  }
};

// 获取本季度统计
const fetchQuarterStats = async() => {
  const year = dayjs().year();
  const quarter = Math.ceil((dayjs().month() + 1) / 3);
  const periodStr = `${year}-Q${quarter}`;
  try {
    const res = await useApi().statisticsApi.getQuarterlyIncomestatistics({ year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    quarterIncome.value = current?.income || '0.00';
  } catch {
    quarterIncome.value = '0.00';
  }
};

// 获取本年统计
const fetchYearStats = async() => {
  const year = dayjs().year();
  const periodStr = String(year);
  try {
    const res = await useApi().statisticsApi.getYearlyIncomestatistics({ startYear: year, endYear: year });
    const list = res.data.data || [];
    const current = list.find((item: any) => item.period === periodStr);
    yearIncome.value = current?.income || '0.00';
  } catch {
    yearIncome.value = '0.00';
  }
};

onMounted(() => {
  fetchTodayStats();
  fetchMonthStats();
  fetchQuarterStats();
  fetchYearStats();
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
